<template>
	<div class="stage stage--intro__round" :style="{ 'background-image': backgroundImage }">

		<div class="stage--intro__round__background-overlay background-overlay">

			<div class="content-container">

				<div class="header__container shadow-box">
					<div class="header" style="position: relative" v-html="roundData.questions.intro_header">
					</div>
					<div class="subHeader" style="position: relative" v-html="roundData.questions.intro_subheader">
					</div>
					<div class="text" style="position: relative" v-html="roundData.questions.intro_explanation">
					</div>
				</div>

				<Lottie
						:animationpath="baseUrl + roundData.questions.intro_visual"
						name="intro-animation"
						loop="true"
						ratio="meet"
						autoplay="true"
						style="margin:auto; position: relative"
						v-if="visualExists && visualIsJson"
				/>

				<div v-else-if="visualExists" class="centered" style="position: relative">
					<img
							:src="baseUrl + roundData.questions.intro_visual"
							class="visual"
					/>
				</div>

			</div>
			
		</div>



	</div>
</template>

<script>

	import {mapGetters , mapActions} from 'vuex';
	import { url} from '../../const/base';
	import Lottie from '../Lottie.vue';

	export default {
		components:{
			Lottie,
		},
		props:[
		],

		mounted(){
			setTimeout(()=>{
				this.setNextButtonAction(()=>{this.toNextRoundState();}).then(()=>{
					this.showNextButton({"btn":true , "btn-progres":true , "btn-progres-utrecht-whiteLine":false});
				});
			},500);

			this.showTransitorScore(false);

		},

		data(){
			return {
				baseUrl : url
			}
		},
		methods:{
			...mapActions([
				'showNextButton',
				'setNextButtonAction',
				'setRoundState',
				"showTransitorScore"
			]),

			toNextRoundState(){
				if(this.roundData.questions.hide_explanation == "Yes") this.setRoundState("Round");
				else this.setRoundState("explanation");
			}
		},
		computed:{
			...mapGetters([
				'stageData',
				'roundData'
			]),

			visualExists(){
				return this.roundData != null && this.roundData.questions.intro_visual != null;
			},

			visualIsJson(){
				if(this.roundData == null || this.roundData.questions.intro_visual == null) return false;
				let fileExtension = this.roundData.questions.intro_visual.substr(this.roundData.questions.intro_visual.lastIndexOf('.') + 1);
				return fileExtension.toLowerCase() == 'json';
			},

			backgroundImage: function() {

				
				if(this.roundData.questions.intro_background === null){ 
					return ''
				}

		        return 'url('+ this.baseUrl + this.roundData.questions.intro_background + ')';
				
		    },
		},

	}
</script>

<style scoped>
	.visual{width:80%;}
</style>


// WEBPACK FOOTER //
// src/components/minigames/RoundIntro.vue